module.exports = '<svg width="37" height="32" viewBox="0 0 37 32"><path d="M.809 10.898C.361 10.45 0 10.601 0 11.232v18.482A2.284 2.284 0 0 0 2.286 32h32a2.284 2.284 0 0 0 2.286-2.286V11.232c0-.631-.361-.782-.809-.334l-16.67 16.67a1.143 1.143 0 0 1-1.616 0L.81 10.898zm34.953-6.466c.448-.446.809-1.106.809-1.477v-.67a2.284 2.284 0 0 0-2.286-2.286h-32A2.284 2.284 0 0 0-.001 2.285v.67c0 .371.361 1.031.809 1.477l16.67 16.67c.446.446 1.17.446 1.616 0l16.667-16.67z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/mail-2.js
// module id = 1252
// module chunks = 14